import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./appSlice";
import userReducer from "./user/userSlice";
import accountReducer from "./account/accountSlice";
import pageReducer from "./page/pageSlice";

const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    account: accountReducer,
    page: pageReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
